Namespace 'Customer.Filters'

class Customer.Filters.VisibleByStatusCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/general/visible_by_status_card']
  className: 'filter-field-container'

  NULL_OPERATOR_ID = 0

  initialize: ({filter, editable}) ->
    @filter = filter
    @editable = editable

  render: ->
    return @ unless Keepcon.operatorStatus

    @$el.html(@template)
    @_addVisibleByStatusesSelector()
    @

  getVisibleByStatuses: =>
    @visibleByStatusesView.toArray()

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  _addVisibleByStatusesSelector: ->
    @visibleByStatusesView = @_selectView()
    @$el.find('#filter-visible-by-statuses').append(@visibleByStatusesView.el)
    @listenTo(@visibleByStatusesView, 'change', @_keepCustomerSessionAlive)

    showStatusVisibility = @editable && Keepcon.canUpdateStatusVisibility
    unless showStatusVisibility
      @visibleByStatusesView.disable()
      @$el.find('#filter-visible-by-statuses')
        .tooltip('show')
        .attr('data-original-title', I18n.t('customer.dashboard.filters.not_allowed'))
        .tooltip('fixTitle')

  _selectView: ->
    operatorStatuses = _.filter(Keepcon.operatorStatus, (operatorStatus) -> operatorStatus.id != NULL_OPERATOR_ID)
    new Customer.Filters.SelectView(
      options: operatorStatuses,
      valueProperty: 'id'
      descriptionProperty: 'name'
      selectedOptions: @filter.get('operator_status_ids')
      placeholder: I18n.t('customer.dashboard.filters.placeholders.add_operator_status')
      title: I18n.t('customer.dashboard.filters.creation.visible_by_statuses')
      editable: @editable
    )
